import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { IndustryHierarchyItemBase } from './industry-hierarchy-item';

export class PlantUnit extends IndustryHierarchyItemBase implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'PlantUnit';
  readonly apiRoute: string = CONFIG.apiRoutes.plantUnit;

  installationId: string;
  loadFromJson(data) {
    super.loadFromJson(data);
    this.installationId = data.installationId;
  }
}
